// extracted by mini-css-extract-plugin
export var addToCartButton = "_s5-b";
export var arrowButtonContainer = "_s5-9";
export var arrowButtonIcon = "_s5-a";
export var carouselArrowButton = "_s5-6";
export var carouselElementContainer = "_s5-1";
export var left = "_s5-7";
export var productDisplayCarouselContainer = "_s5-0";
export var productTileContainer = "_s5-2";
export var productTileImage = "_s5-4";
export var productTileImageContainer = "_s5-3";
export var productTileTitle = "_s5-5";
export var right = "_s5-8";
export var sliderOverflow = "_s5-c";